<script setup>
import {useRouting} from "@/composables/routing.js";
const {href,url} = useRouting();

import { Head } from '@inertiajs/vue3'
import { Link } from '@inertiajs/vue3';
</script>

<template>
    <Head>
        <title>Imprint</title>
        <meta name="description" content="Imprint of the LAY7 cloud. Information according to §5 TMG">
        <link rel="canonical" :href="url('/legal/imprint', 'en')">
        <link rel="alternate" hreflang="de" :href="url('/legal/imprint', 'de')">
        <link rel="alternate" hreflang="en" :href="url('/legal/imprint', 'en')">
        <meta name="robots" content="noindex, nofollow">
    </Head>
    <section>
        <div class="container px-4 mx-auto mt-28 lg:mt-36">
            <h1 class="font-semibold text-4xl text-black space-x-3 mb-3">
                Imprint
            </h1>
            <p>
                Information according to §5 TMG
            </p>
            <p class="mt-2">
                <br>
                Tobias Holst e.K
                <br>
                Richard-Strauss-Str. 13
                <br>
                81677 München
                <br>
                GERMANY
            </p>
        </div>
    </section>

    <section class="mt-8 lg:mt-12">
        <div class="container px-4 mx-auto">
            <h2 class="font-semibold text-3xl text-black space-x-3 mb-5">
                Contact
            </h2>
            <p class="mt-2">
                Phone: +49 89 339 80 65 0
                <br>
                Fax: +49 89 339 80 65 99
                <br>
                Mail: support@lay7.cloud
            </p>
            <p class="mt-4 text-black text-lg font-bold">
                VAT ID according to §27a sales tax law:
            </p>
            <p>
                DE 299 09 12 83
            </p>
            <p class="text-gray-500 mt-4">
                Source: http://www.e-recht24.de
            </p>
        </div>
    </section>

    <section class="mt-8 lg:mt-12">
        <div class="container px-4 mx-auto">
            <h2 class="font-semibold text-3xl text-black space-x-3 mb-5">
                Haftungsausschluss (Disclaimer)
            </h2>
            <p class="mt-4 text-black text-lg font-bold">
                Liability for content
            </p>
            <p>
                As a service provider, we are responsible for our own content on these pages in accordance with Section 7 (1) of the German Telemedia Act (TMG). According to §8 to §10 TMG, however, we as a service provider are not obliged to monitor transmitted or stored third-party information or to investigate circumstances that indicate illegal activity. Obligations to remove or block the use of information in accordance with general legislation remain unaffected by this. However, liability in this respect is only possible from the time of knowledge of a specific infringement. As soon as we become aware of such infringements, we will remove this content immediately.
            </p>
            <p class="mt-4 text-black text-lg font-bold">
                Liability for links
            </p>
            <p>
                Our website contains links to external third-party websites over whose content we have no influence. Therefore, we cannot accept any liability for this third-party content. The respective provider or operator of the pages is always responsible for the content of the linked pages. The linked pages were checked for possible legal violations at the time of linking. Illegal content was not recognizable at the time of linking. However, permanent monitoring of the content of the linked pages is not reasonable without concrete evidence of an infringement. If we become aware of any legal infringements, we will remove such links immediately.
            </p>
            <p class="mt-4 text-black text-lg font-bold">
                Copyright
            </p>
            <p>
                The content and works created by the site operators on these pages are subject to German copyright law. Reproduction, editing, distribution and any kind of exploitation outside the limits of copyright law require the written consent of the respective author or creator. Downloads and copies of this site are only permitted for private, non-commercial use. Insofar as the content on this site was not created by the operator, the copyrights of third parties are respected. In particular, third-party content is identified as such. Should you nevertheless become aware of a copyright infringement, please inform us accordingly. If we become aware of any infringements, we will remove such content immediately.
            </p>
        </div>
    </section>
</template>
